import { RouterProvider } from "react-router-dom"
import { Provider as ReduxProvider } from "react-redux"
import { faClose } from "@fortawesome/pro-light-svg-icons"
import { SnackbarProvider, closeSnackbar } from "notistack"
import { QueryClientProvider } from "@tanstack/react-query"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { ThemeProvider, CssBaseline, IconButton } from "@mui/material"
import { AppLocalizationProvider } from "./modules/localization/components/AppLocalizationProvider"
import { MuiLocalizationProvider } from "./modules/localization/components/MuiLocalizationProvider"
import { useLogVersionBanner } from "./modules/environment/components/AppVersion"
import { ConfigPoller } from "./modules/config/ConfigPoller"
import { queryClient } from "./core/api/queryClient"
import { theme } from "./modules/theme/theme"
import { router } from "./core/router/router"
import { store } from "./modules/store/store"
import { ErrorAdapter } from "./shared/components/errors/ErrorAdapter"

export const App = () => {
    useLogVersionBanner()

    return (
        <ReduxProvider store={store}>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <SnackbarProvider
                    anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                    hideIconVariant
                    preventDuplicate
                    action={(key) => (
                        <IconButton onClick={() => closeSnackbar(key)}>
                            <FontAwesomeIcon icon={faClose} size="xs" color="white" />
                        </IconButton>
                    )}
                >
                    <AppLocalizationProvider>
                        <MuiLocalizationProvider>
                            <QueryClientProvider client={queryClient}>
                                <ConfigPoller>
                                    <ErrorAdapter>
                                        <RouterProvider router={router} />
                                    </ErrorAdapter>
                                </ConfigPoller>
                                <ReactQueryDevtools initialIsOpen={false} />
                            </QueryClientProvider>
                        </MuiLocalizationProvider>
                    </AppLocalizationProvider>
                </SnackbarProvider>
            </ThemeProvider>
        </ReduxProvider>
    )
}
